// extracted by css-extract-rspack-plugin
export default {"item":"Timeline-module__item___Xvio5","itemTitle":"Timeline-module__itemTitle___PBCJy","itemBullet":"Timeline-module__itemBullet___raFy9"};